
import privateAxiosInstance from "../utils/axios/private";
import { hybridDecrypt } from "../utils/crypto";

export const adminDashboard = {

    async adminOverview() {
        try {
            const response = await privateAxiosInstance.get("/dashboard/admin/overview/");
            if (response.data.encrypted) {
                // console.log(await hybridDecrypt(response.data.data))
                return await hybridDecrypt(response.data);
            }
            return response.data.data
        }
        catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    async adminJobs() {
        try {
            const response = await privateAxiosInstance.get("/dashboard/admin/jobs/");
            if (response.data.encrypted) {
                // console.log(await hybridDecrypt(response.data.data))
                return await hybridDecrypt(response.data);
            }
            return response.data.data
        }
        catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },
    async adminRecruiters() {
        try {
            const response = await privateAxiosInstance.get("/dashboard/admin/recruiters/");
            if (response.data.encrypted) {
                // console.log(await hybridDecrypt(response.data.data))
                return await hybridDecrypt(response.data);
            }
            return response.data.data
        }
        catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },
};


export const recruiterDashboard = {

    async recruiterOverview() {
        try {
            const response = await privateAxiosInstance.get("/dashboard/recruiter/overview/");
            if (response.data.encrypted) {
                // console.log(await hybridDecrypt(response.data.data))
                return await hybridDecrypt(response.data);
            }
            return response.data.data
        }
        catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    async recruiterJobs() {
        try {
            const response = await privateAxiosInstance.get("/dashboard/recruiter/jobs/");
            if (response.data.encrypted) {
                // console.log(await hybridDecrypt(response.data.data))
                return await hybridDecrypt(response.data);
            }
            return response.data.data
        }
        catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },
    async recruiterInterviews() {
        try {
            const response = await privateAxiosInstance.get("/dashboard/recruiter/interviews/");
            if (response.data.encrypted) {
                // console.log(await hybridDecrypt(response.data.data))
                return await hybridDecrypt(response.data);
            }
            return response.data.data
        }
        catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },
};
